
import breadcrumb from "../library/breadcrumb.vue"
import { getSimilarList } from "../api/gateway"
import similarWare from "../components/similarWare/similarWare"
import getCartNumMixin from "@/mixins/getCartNum"
import { Logger } from "@/plugins/logger"
import { getRequestHeaders, formatProductParamsBy } from "@/utils/utils"
export default {
  name: "Similar",
  components: {
    similarWare,
    breadcrumb
  },
  mixins: [getCartNumMixin],
  validate({ query }) {
    return query.skuId
  },
  props: {
    configs: {
      type: Object,
      default: () => {}
    }
  },
  async asyncData({ route, req, store, error, $cookies }) {
    try {
      const { data } = await getSimilarList(
        {
          param: formatProductParamsBy({ skuId: route.query.skuId }, $cookies),
          comm: {}
        },
        {
          loading: true,
          headers: getRequestHeaders({ req, store })
        }
      )
      return {
        similarList: data.similarList || []
      }
    } catch (err) {
      Logger.error("同类商品推荐", err)
      error({
        statusCode: 500,
        message: "Internal Server Error"
      })
    }
  },
  data() {
    return {
      similarList: [],
      breadcrumbData: [
        {
          name: this.$t("common.home"),
          path: "/"
        },
        {
          name: this.$t("common.similarProducts")
        }
      ]
    }
  },
  head() {
    return {
      title: this.pageTitle
    }
  },
  computed: {
    hasWare() {
      return this.wareList.length > 0
    }
  }
}
